export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/Return.0158de93.svg","height":17,"width":15,"blurWidth":0,"blurHeight":0};